import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { AppRouter } from "./approuter";
import { Auth } from "aws-amplify";
import Login from "./pages/Login/Login";
import Unauthorized from "./components/unauthorized";
import AuthService from "./Auth";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userGroup, setUserGroup] = useState(null);
  useEffect(() => {
    const authenticateUser = async () => {
      try {
        if (await Auth.currentSession()) {
          setIsLoading(false);
          setIsAuthenticated(true);
          const group = await AuthService.currenUserGroup();
          setUserGroup(group);
        }
      } catch (e) {
        if (e !== "No current user") {
          alert(e);
        }
        setIsLoading(false);
        setIsAuthenticated(false);
      }
    };

    authenticateUser();
  }, []);

  return (
    <>
      {isLoading ? (
        <div
          // style={{
          //   position: "fixed",
          //   top: 0,
          //   left: 0,
          //   width: "100%",
          //   height: "100%",
          //   backgroundColor: "rgba(0, 0, 0, 0.5)",
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   zIndex: 9999,
          // }}
        >
          {/* <Spinner animation="border" variant="light"></Spinner>
          <p
            style={{ marginLeft: "20px", color: "whitesmoke" }}
            className="page-title  mt-3"
          >
            Customer Portal loading...
          </p> */}
        </div>
      ) :
      isAuthenticated ? (
        userGroup === "Client" ? (
          <AppRouter />
        ) : (
          <Unauthorized />
        )
      ) : (
        <Login />
      )}
    </>
  );
}

export default App;
